import { render, staticRenderFns } from "./BannerLeaderboard.vue?vue&type=template&id=1150925a&scoped=true&lang=pug&"
import script from "./BannerLeaderboard.vue?vue&type=script&lang=js&"
export * from "./BannerLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./BannerLeaderboard.vue?vue&type=style&index=0&id=1150925a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1150925a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
